export default {"src":"/_next/static/media/spa.621576b8.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};